/* Réplica visual do popup Alia (2 passos). Envio desativado: o e-mail não é enviado nem gera código (regra do dono
   para formulários externos). Fecha pelo X ou "No thanks" e não reaparece para o mesmo visitante. */
(function () {
  var box = document.getElementById('tcb-alia');
  if (!box) return;
  var mob = function () { return window.innerWidth < 768; };   // o app usa marcação própria no celular
  var tpl = function (n) { var t = document.getElementById('tcb-alia-' + (mob() ? 'm' : 'd') + n); return t ? t.innerHTML : ''; };
  var KEY = 'tcb-alia-closed';
  try { if (localStorage.getItem(KEY)) return; } catch (e) {}
  function close() {
    box.hidden = true;
    try { localStorage.setItem(KEY, '1'); } catch (e) {}
  }
  box.addEventListener('click', function (e) {
    var t = e.target;
    if (t.closest('[aria-label="Close popup"]')) { close(); return; }
    var b = t.closest('button');
    if (!b) return;
    var txt = b.textContent.trim();
    if (txt === 'No thanks') { close(); return; }
    if (txt === 'Myself' || txt === 'Someone else') { box.innerHTML = tpl(2); return; }
    if (b.type === 'submit') e.preventDefault();          // envio desativado
  });
  box.addEventListener('submit', function (e) { e.preventDefault(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !box.hidden) close(); });
  setTimeout(function () { box.innerHTML = tpl(1); box.hidden = false; }, 2500);
})();

/* Página /cart: quantidade (+/−/digitação) via /cart/change.js e recarga, com o overlay de carregamento do tema. */
(function () {
  var root = document.querySelector('cart-items');
  if (!root) return;
  fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); })
    .then(window.tcbDropOrphans).then(function (c) { if (c) location.reload(); });
  var busy = false;
  root.addEventListener('change', function (e) {
    var input = e.target.closest && e.target.closest('input[name="updates[]"]');
    if (!input || busy) return;
    busy = true;
    var row = input.closest('.cart-item');
    if (row) row.querySelectorAll('.loading-overlay').forEach(function (o) { o.classList.remove('hidden'); });
    fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: +input.dataset.index, quantity: Math.max(0, parseInt(input.value, 10) || 0) }) })
      .then(function () { location.reload(); })
      .catch(function () { busy = false; location.reload(); });
  });
})();

/* Judge.me (widget renderizado, espelhado): o script do app ajusta o widget à largura — classe --small (< ~425px) ou
   --medium (< ~675px). "Write a review" fica visível (estado estável na referência; o display:none da captura é transitório). */
(function () {
  var ws = document.querySelectorAll('.jdgm-widget.jdgm-review-widget');
  if (!ws.length) return;
  function fit(w) {
    var width = w.getBoundingClientRect().width;
    if (!width) return;
    var size = width < 425 ? 'small' : width < 675 ? 'medium' : '';
    w.classList.toggle('jdgm-review-widget--small', size === 'small');
    w.classList.toggle('jdgm-review-widget--medium', size === 'medium');
    w.querySelectorAll('.jdgm-write-rev-link').forEach(function (a) { a.style.display = ''; });
  }
  ws.forEach(function (w) {
    fit(w);
    if (window.ResizeObserver) new ResizeObserver(function () { fit(w); }).observe(w);
  });
})();

/* Réplica do bloco Kaching Bundles: seleção da barra, cor por unidade, preços da barra e envio ao carrinho. */
(function () {
  document.querySelectorAll('[data-tcb-kaching]').forEach(function (k) {
    var vars = JSON.parse(k.getAttribute('data-variants') || '[]');
    var byOpt = function (o) { return vars.filter(function (v) { return v.o === o; })[0] || vars[0]; };
    var bars = Array.prototype.slice.call(k.querySelectorAll('.kaching-bundles__bars > .kaching-bundles__bar'));
    var fmt = window.tcbMoney;
    function price(bar) {
      var paid = +bar.getAttribute('data-paid'), free = +bar.getAttribute('data-free');
      var sel = Array.prototype.slice.call(bar.querySelectorAll('select[data-tcb-unit]')).map(function (s) { return byOpt(s.value); });
      if (!sel.length) sel = [vars[0]];
      while (sel.length < paid + free) sel.push(sel[sel.length - 1]);
      var p = sel.slice(0, paid).reduce(function (a, v) { return a + v.price; }, 0);
      var c = sel.reduce(function (a, v) { return a + v.compare; }, 0);
      bar.querySelector('[data-tcb-price]').textContent = fmt(p);
      bar.querySelector('[data-tcb-compare]').textContent = fmt(c);
    }
    function select(bar) {
      bars.forEach(function (b) { b.classList.toggle('kaching-bundles__bar--selected', b === bar); });
      var i = bar.querySelector('input[type=radio]'); if (i) i.checked = true;
    }
    // variante esgotada: opção desabilitada na unidade (nunca trocada por outra)
    k.querySelectorAll('select[data-tcb-unit] option').forEach(function (o) {
      var v = vars.filter(function (x) { return x.o === o.value; })[0];
      if (v && v.available === false) o.disabled = true;
    });
    bars.forEach(function (bar) {
      bar.addEventListener('click', function (e) { if (!e.target.closest('select')) select(bar); });
      bar.querySelectorAll('select[data-tcb-unit]').forEach(function (s) {
        s.addEventListener('change', function () { s.setAttribute('data-value', s.value); price(bar); });
      });
      price(bar);
    });
    // upsell por checkbox (Elite Care)
    var up = k.querySelector('[data-tcb-upsell]');
    if (up) {
      var main = up.querySelector('[role=checkbox]'), box = up.querySelector('.kaching-bundles__checkbox-upsells__checkbox');
      var toggle = function () {
        var on = main.getAttribute('aria-checked') !== 'true';
        main.setAttribute('aria-checked', on); up.classList.toggle('kaching-bundles__bar--selected', on);
        box.classList.toggle('kaching-bundles__checkbox-upsells__checkbox--selected', on);
      };
      main.addEventListener('click', toggle);
      main.addEventListener('keydown', function (e) { if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); toggle(); } });
    }
    // cor escolhida no seletor principal (variant-radios) vale para todas as unidades de todas as barras, como no app
    document.addEventListener('change', function (e) {
      var r = e.target;
      if (!r.closest || !r.closest('variant-radios, variant-selects')) return;
      bars.forEach(function (bar) {
        bar.querySelectorAll('select[data-tcb-unit]').forEach(function (s) { s.value = r.value; s.setAttribute('data-value', r.value); });
        price(bar);
      });
    });
    // envio: a barra escolhida define os itens (pagos + grátis), mais o upsell marcado
    var form = k.closest('product-info, .product') && k.closest('.product').querySelector('form[action$="/cart/add"]');
    if (!form) form = document.querySelector('product-form form[action$="/cart/add"]');
    if (!form) return;
    form.addEventListener('submit', function (e) {
      e.preventDefault(); e.stopImmediatePropagation();
      var bar = k.querySelector('.kaching-bundles__bars > .kaching-bundles__bar--selected') || bars[0];
      var paid = +bar.getAttribute('data-paid'), free = +bar.getAttribute('data-free');
      var chosen = Array.prototype.slice.call(bar.querySelectorAll('select[data-tcb-unit]')).map(function (s) { return vars.filter(function (x) { return x.o === s.value; })[0]; });
      var err = form.closest('product-form') && form.closest('product-form').querySelector('.product-form__error-message');
      if (chosen.some(function (v) { return !v || v.available === false; })) {
        if (err) { err.textContent = 'Sold out'; err.parentElement.hidden = false; }
        return;
      }
      var sel = chosen.map(function (v) { return v.id; });
      if (!sel.length) sel = [+form.querySelector('input[name=id]').value];
      while (sel.length < paid + free) sel.push(sel[sel.length - 1]);
      var counts = {};
      sel.forEach(function (id) { counts[id] = (counts[id] || 0) + 1; });
      var items = Object.keys(counts).map(function (id) { return { id: +id, quantity: counts[id] }; });
      // Elite Care: linha própria a $0, como na referência; usa o plano de assinatura da loja quando existir
      if (up && up.querySelector('[role=checkbox]').getAttribute('aria-checked') === 'true') {
        var pid = form.querySelector('input[name="product-id"]');
        var el = { id: +up.getAttribute('data-tcb-upsell'), quantity: 1, properties: { _tcb_upsell: pid ? pid.value : '' } }, plan = up.getAttribute('data-tcb-plan');
        if (plan) el.selling_plan = +plan;
        items.unshift(el);
      }
      var btn = form.querySelector('[type=submit]');
      btn.classList.add('loading'); btn.setAttribute('aria-disabled', 'true');
      var sp = btn.querySelector('.loading__spinner, .loading-overlay__spinner'); if (sp) sp.classList.remove('hidden');
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Error'); return j; }); })
        .then(function () { window.tcbCart.open(); })
        .catch(function (x) { var m = form.closest('product-form') && form.closest('product-form').querySelector('.product-form__error-message'); if (m) { m.textContent = x.message; m.parentElement.hidden = false; } })
        .finally(function () { btn.classList.remove('loading'); btn.removeAttribute('aria-disabled'); if (sp) sp.classList.add('hidden'); });
    }, true);
  });
})();

/* Página de produto aberta por ?variant=: a mídia da variante vem primeiro na galeria e na lista de miniaturas,
   como o main-product do Dawn renderiza no servidor (a classe is-active já vem do Liquid). */
(function () {
  if (!/[?&]variant=/.test(location.search)) return;
  document.querySelectorAll('media-gallery').forEach(function (g) {
    var active = g.querySelector('[data-media-id].is-active');
    if (!active || active === active.parentElement.firstElementChild) return;
    active.parentElement.prepend(active);
    var id = active.getAttribute('data-media-id');
    var th = g.querySelector('[data-target="' + id + '"]');
    if (th) th.parentElement.prepend(th);
    var viewer = g.querySelector('slider-component');
    if (viewer && viewer.resetPages) viewer.resetPages();
    if (th && g.setActiveThumbnail) g.setActiveThumbnail(th);
  });
})();

/* Kaching Bundles: na referência o upsell da caixinha (Elite Care) vem marcado ao abrir a página ("preselected"),
   opção que a versão atual do app não oferece no editor. Marca uma única vez, com o clique do próprio app;
   depois o cliente desmarca normalmente. */
(function () {
  var done = false;
  function tick() {
    if (done) return true;
    var box = document.querySelector('kaching-bundle .kaching-bundles__checkbox-upsells__upsell .kaching-bundles__bar-main[role=checkbox]');
    if (!box) return false;
    done = true;
    if (box.getAttribute('aria-checked') !== 'true') box.click();
    return true;
  }
  if (!document.querySelector('script.kaching-bundles-deal-block-settings, kaching-bundle') && !/\/products\//.test(location.pathname)) return;
  var mo = new MutationObserver(function () { if (tick()) mo.disconnect(); });
  mo.observe(document.documentElement, { childList: true, subtree: true });
  tick() && mo.disconnect();
  setTimeout(function () { mo.disconnect(); }, 20000);
})();

/* Réplica do UpCart (gaveta do carrinho da referência) com o carrinho desta loja. */
(function () {
  var host = document.getElementById('shopify-block-tcb-upcart');
  if (!host) return;
  var pop = host.querySelector('#UpcartPopup');
  var bd = host.querySelector('#UpcartPopupBackDrop');
  var cp = host.querySelector('#CartPopup');
  var card = host.querySelector('.styles_CartPreview__card__');
  var fullKids = Array.prototype.slice.call(card.children);
  var list = host.querySelector('[data-tcb-items]');
  var title = host.querySelector('[data-tcb-title]');
  var addon = host.querySelector('[data-tcb-protection]');
  var toggle = host.querySelector('[data-tcb-toggle]');
  var codes = host.querySelector('[data-tcb-codes]');
  var discount = host.querySelector('[data-tcb-discount]');
  var summary = host.querySelector('[data-tcb-summary]');
  var checkout = host.querySelector('[data-tcb-checkout]');
  var tItem = document.getElementById('tcb-upcart-item').innerHTML;
  var tTag = document.getElementById('tcb-upcart-tag').innerHTML;
  var tTags = document.getElementById('tcb-upcart-tags').innerHTML;
  var tEmpty = document.getElementById('tcb-upcart-empty').innerHTML;
  var protectionId = addon ? +addon.getAttribute('data-tcb-protection') : 0;
  var emptyNodes = null, busy = false, cartState = null, CMP = {};
  try { CMP = JSON.parse(document.getElementById('tcb-upcart-compare').textContent); } catch (err) {}

  var fmt = window.tcbMoney;
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function img(u) { return u ? u + (u.indexOf('?') > -1 ? '&' : '?') + 'height=176' : ''; }

  var HIDE = ['Elite Care™', 'Elite Care™ Free', 'Elite Care™ Free with bottle'];  // na referência o Elite Care sai a $0 por assinatura, sem etiqueta de desconto
  var ELITE_H = 'elite-vip-membership';
  function nb(t) { return String(t).replace(/ /g, ' '); }   // versões das ofertas com Elite usam espaço não separável no título
  function tagsOf(it) {
    if (it.handle === ELITE_H) return '';
    var a = (it.line_level_discount_allocations || []).filter(function (d) { return d.amount > 0; }).map(function (d) { return nb(d.discount_application.title); }).filter(function (t) { return HIDE.indexOf(t) < 0; });
    return a.length ? tTags.replace('%T%', a.map(function (x) { return tTag.replace(/>[^<>]*<\/span><\/span>$/, '>' + esc(x) + '</span></span>'); }).join('')) : '';
  }

  var dropping = false;
  function render(cart) {
    if (!dropping && window.tcbOrphans(cart).length) {
      dropping = true;
      window.tcbDropOrphans(cart).then(function (c) { render(c && c.items ? c : cart); }, function () { render(cart); })
        .then(function () { dropping = false; });
      return;
    }
    cartState = cart;
    var items = (cart.items || []).filter(function (it) { return it.variant_id !== protectionId; });
    var count = cart.item_count - (cart.items || []).filter(function (it) { return it.variant_id === protectionId; }).reduce(function (a, it) { return a + it.quantity; }, 0);
    if (!items.length) {
      fullKids.forEach(function (k) { k.style.display = 'none'; });
      if (!emptyNodes) { var d = document.createElement('div'); d.innerHTML = tEmpty; emptyNodes = Array.prototype.slice.call(d.children); }
      emptyNodes.forEach(function (n) { card.appendChild(n); });
    } else {
      if (emptyNodes) emptyNodes.forEach(function (n) { if (n.parentNode) n.remove(); });
      fullKids.forEach(function (k) { k.style.display = ''; });
      title.textContent = 'Cart • ' + count;
      list.innerHTML = items.map(function (it) {
        var cmp = Math.max((CMP[it.variant_id] || 0) * it.quantity, it.original_line_price);
        var save = cmp - it.final_line_price;
        var variant = (it.options_with_values || []).filter(function (o) { return o.value !== 'Default Title'; })
          .map(function (o) { return '<span class="upcart-internal-cart-items__key-value-pair">' + esc(o.name + ': ' + o.value) + '</span>'; }).join('');
        // assinatura: nome do plano (Elite Care na referência: "1 month subscription with 100% discount"; decisão do dono 27/09:
        // mesmo visual antes do app de assinaturas; com o app, o nome vem do plano real)
        var plan = it.selling_plan_allocation ? it.selling_plan_allocation.selling_plan.name : (it.handle === 'elite-vip-membership' ? '1 month subscription with 100% discount' : '');
        var props = plan ? '<div><p class="upcart-public-product-properties__subscription">' + esc(plan) + '</p></div>' : '';
        var h = tItem.split('%KEY%').join(esc(it.key)).split('%URL%').join(esc(it.url)).split('%IMG%').join(esc(img(it.image)))
          .split('%TITLE%').join(esc(it.product_title)).split('%VARIANT%').join(variant).split('%QTY%').join(it.quantity)
          .split('%COMPARE%').join(save > 0 ? fmt(cmp) : '').split('%PRICE%').join(fmt(it.final_line_price))
          .split('%SAVE%').join(save > 0 ? '(Save ' + fmt(save) + ')' : '').split('%PROPS%').join(props).split('%TAGS%').join(tagsOf(it));
        if (save <= 0) h = h.replace(/<span class="upcart-internal__visually-hidden">Original price<\/span><span[^>]*><\/span>/, '')
          .replace(/<span class="upcart-internal__visually-hidden">Savings<\/span><span[^>]*><\/span>/, '');
        return h;
      }).join('');
      // upsells: produto já no carrinho não aparece
      host.querySelectorAll('[data-tcb-upsell]').forEach(function (u) {
        var pid = +u.getAttribute('data-tcb-product');
        var box = u.parentNode && u.parentNode.parentNode;
        (box || u).style.display = (cart.items || []).some(function (it) { return it.product_id === pid; }) ? 'none' : '';
      });
      if (toggle) toggle.checked = (cart.items || []).some(function (it) { return it.variant_id === protectionId; });
      var titles = [];
      (cart.cart_level_discount_applications || []).forEach(function (d) { if (HIDE.indexOf(d.title) < 0) titles.push(d.title); });
      var hidden = 0;
      (cart.items || []).forEach(function (it) { (it.line_level_discount_allocations || []).forEach(function (d) { var t = nb(d.discount_application.title); if (HIDE.indexOf(t) >= 0 || it.handle === ELITE_H) { hidden += d.amount; return; } if (titles.indexOf(t) < 0) titles.push(t); }); });
      codes.innerHTML = titles.map(function (x) { return tTag.replace(/>[^<>]*<\/span><\/span>$/, '>' + esc(x) + '</span></span>'); }).join('');
      discount.textContent = '- ' + fmt(cart.total_discount - hidden);
      summary.style.display = cart.total_discount - hidden > 0 ? '' : 'none';
      checkout.textContent = 'Checkout • ' + fmt(cart.total_price);
    }
    document.querySelectorAll('#cart-icon-bubble').forEach(function (a) {
      var b = a.querySelector('.cart-count-bubble');
      if (cart.item_count > 0) {
        if (!b) { b = document.createElement('div'); b.className = 'cart-count-bubble'; a.appendChild(b); }
        b.innerHTML = '<span aria-hidden="true">' + cart.item_count + '</span><span class="visually-hidden">' + cart.item_count + ' items</span>';
      } else if (b) b.remove();
    });
  }

  function load() { return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }
  function open(cart) {
    (cart && cart.items ? Promise.resolve(cart) : load()).then(render);
    pop.className = 'upcartPopupShow'; cp.classList.add('styles_active__');
    bd.className = 'upcart-backdrop styles_CartPreview__backdrop__ styles_active__';
    document.body.classList.add('upcart-open');
  }
  function close() {
    pop.removeAttribute('class'); cp.classList.remove('styles_active__');
    bd.className = 'upcart-backdrop styles_CartPreview__backdrop__';
    document.body.classList.remove('upcart-open');
  }
  function post(url, body) {
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json(); });
  }
  function change(key, qty) {
    if (busy) return; busy = true;
    post('/cart/change.js', { id: key, quantity: Math.max(0, qty) }).then(function (c) { busy = false; c && c.items ? render(c) : load().then(render); if (/^\/cart\/?$/.test(location.pathname)) location.reload(); })
      .catch(function () { busy = false; load().then(render); });
  }
  function add(id) {
    if (busy) return; busy = true;
    post('/cart/add.js', { items: [{ id: id, quantity: 1 }] }).then(load).then(function (c) { busy = false; render(c); })
      .catch(function () { busy = false; });
  }

  host.addEventListener('click', function (e) {
    var t = e.target;
    if (t.closest('.upcart-public-header__close-button') || t.closest('#UpcartPopupBackDrop')) { close(); return; }
    var up = t.closest('[data-tcb-upsell]');
    if (up && t.closest('button')) { add(+up.getAttribute('data-tcb-upsell')); return; }
    var row = t.closest('[data-key]');
    if (!row) return;
    var key = row.getAttribute('data-key');
    var q = parseInt(row.querySelector('input').value, 10) || 1;
    if (t.closest('.upcart-public-component-product-tile__quantity-minus')) change(key, q - 1);
    else if (t.closest('.upcart-public-component-product-tile__quantity-plus')) change(key, q + 1);
    else if (t.closest('.upcart-public-component-product-tile__remove-button')) change(key, 0);
  });
  host.addEventListener('change', function (e) {
    if (e.target === toggle) {
      var line = (cartState.items || []).filter(function (it) { return it.variant_id === protectionId; })[0];
      if (toggle.checked && !line) add(protectionId); else if (!toggle.checked && line) change(line.key, 0);
      return;
    }
    var row = e.target.closest('[data-key]');
    if (row) change(row.getAttribute('data-key'), parseInt(e.target.value, 10) || 0);
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && pop.className) close(); });
  // ícone e links do carrinho abrem a gaveta, como na referência
  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey) return;
    var a = e.target.closest && e.target.closest('a');
    if (a && !host.contains(a) && /^\/cart\/?$/.test(a.getAttribute('href') || '')) { e.preventDefault(); open(); }
  }, true);

  window.tcbCart.open = open;
  try { render(JSON.parse(document.getElementById('tcb-upcart-initial').textContent)); } catch (err) {}
})();
